import { ICotizacion } from './../models/icotizacion';
import { ROUTE_COMERCIAL } from './../constants/constant.model';
import { ApiService } from './api.service';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class CotizacionService {


  constructor(
    private apiService: ApiService,
    private httpClient: HttpClient
  ) { }

  insertarCotizacion(data: ICotizacion): Observable<any> {
    this.apiService.setUrlPathApi(ROUTE_COMERCIAL.crudCotizacion);
    return this.apiService.executePostJson(data).pipe();
  }

  actualizarCotizacion(data: ICotizacion): Observable<any> {
    this.apiService.setUrlPathApi(ROUTE_COMERCIAL.crudCotizacion);
    return this.apiService.executePutJson(data).pipe();
  }

  obtenerCotizacion(numint: number): Observable<any> {
    this.apiService.setUrlPathApi(ROUTE_COMERCIAL.crudCotizacion);
    return this.apiService.execGetQueryJson(`/${numint}`).pipe();
  }

  buscarCotizacion(fdesde: string, fhasta: string, situac: string, lugemi: number, limit: number, offset: number): Observable<any> {
    this.apiService.setUrlPathApi(ROUTE_COMERCIAL.buscarCotizacion);
    return this.apiService.execGetQueryJson(`fdesde=${fdesde}&fhasta=${fhasta}&situac=${situac}&lugemi=${lugemi}&limit=${limit}&offset=${offset}`).pipe();
  }

  calcularCotizacion(data: ICotizacion): Observable<any> {
    this.apiService.setUrlPathApi(ROUTE_COMERCIAL.calcularCotizacion);
    return this.apiService.executePutJson(data).pipe();
  }

  descargarPDF(numint: number, cia: string): Observable<any> {
    this.apiService.setUrlPathApi(ROUTE_COMERCIAL.crudCotizacion);
    return this.apiService.execGetQueryJsonPDF(`/${numint}/report/public/format-default.pdf?cia=${cia}`).pipe();
  }


  reutilizarGuia(serie: number, numdoc: number) {
    this.apiService.setUrlPathApi(ROUTE_COMERCIAL.crudCotizacion);
    return this.apiService.execGetQueryJson(`/${serie}/${numdoc}`).pipe();
  }


  public anular(numint: number, coduser: string) {
    return this.httpClient.put(environment.serviceUrl + "cotizacion/" + numint + "/anular?coduser=" + coduser, null, { observe: 'response' },)
  }

  getSaldoDisponible(codcli: string): Observable<any> {
    this.apiService.setUrlPathApi(`cliente/${codcli}/saldo-disponible`);
    return this.apiService.execGetQueryJson("").pipe();
  }

}
